import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Spin, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

type SaveAndDeleteButtonsProps = {
  readonly onSave: () => void;
  readonly onDelete: () => void;
  readonly saveButtonDisabled: boolean;
  readonly showDelete: boolean;
  readonly showSave: boolean;
  readonly routeOnDelete: string;
  readonly loading: boolean;
  readonly roleId: string;
};

/**
 * @returns Two adjacent buttons, enabling a 'save' and 'delete' action.
 */
const SaveAndDeleteButtons = (props: SaveAndDeleteButtonsProps) => {
  const navigate = useNavigate();

  return (
    <Row>
      {props.showSave && (
        <Button
          id={`save-team-role-btn-${props.roleId}`}
          className="save-btn"
          style={{ float: 'right' }}
          type="primary"
          onClick={props.onSave}
          disabled={props.saveButtonDisabled}
        >
          {props.loading ? <Spin /> : <CheckOutlined />}
        </Button>
      )}

      {props.showDelete && (
        <Button
          id={`delete-team-role-btn-${props.roleId}`}
          className="delete-btn"
          type="primary"
          onClick={() => {
            navigate(props.routeOnDelete);
            props.onDelete();
          }}
          danger
          style={{ float: 'right' }}
        >
          <DeleteOutlined />
        </Button>
      )}
    </Row>
  );
};

export default SaveAndDeleteButtons;
